import runTogglerPreloading from '@markup/Systems/TogglerPreloading'
import { setWebpackBuildInfo } from '@entities/helpers/set-webpack-bundle-info'
import * as tester from '@entities/helpers/testers'
import { persistInitials } from '@entities/helpers/persist-initials'
import { applyCustomizeConfig } from '@entities/helpers/apply-customize-config'
import PagerBackgroundModule from '@module:pager-background'
import Logger from '@services/logger'
import { getConfig } from '@services/context'
import DevicesService from '@services/device'
import { $config, setConfig } from '@store/config'
import { fetchThreadsFx } from '@store/threads'
import { Entity } from '@loctypes'
import { initialConfig, prepareRootContainers } from './helpers'
import { initialConfigCallback } from '@misc/initial-config-callback'

main()

async function main(): Promise<void> {
  const entity: Entity = 'chat.corner'
  const { clientKey, onlyApiWay, customizing, visitorAttributes } = getConfig()

  setWebpackBuildInfo()

  try {
    tester.isThereGlobalConfig()
    tester.isThereRootSelector(entity)
    tester.checkVisitorAttributes()

    persistInitials(entity)
    prepareRootContainers(entity)

    await initialConfig(entity, getConfig())
    applyCustomizeConfig(customizing)

    !onlyApiWay && runTogglerPreloading(entity)

    const config = $config.getState()
    // конфигурируем background для welcome
    PagerBackgroundModule.configure(config)

    // для мобильных принудительно ставим border-radius: 0
    if (DevicesService.isMobile) {
      config.modules.chat.corner.pager.borderRadius = 0
    }
    setConfig(config)

    await Promise.all([
      fetchThreadsFx({ clientKey, algorithm: visitorAttributes?.system?.algorithm }),
      PagerBackgroundModule.calculateValue()
    ])

    import(/* webpackMode: "lazy", webpackChunkName: "common-modules" */ '../helpers/common-modules').then((module) => {
      module.LazyLoad(entity)
    })
    initialConfigCallback('onLoad')
  } catch (e) {
    Logger(e.message)
  }
}